export default __webpack_public_path__ + "static/media/reporthelp-detailE.a4cc6f34.png";